module.exports = __webpack_public_path__ + "img/dinesh.5e8d7026.jpg";